import { Navigate } from 'react-router-dom';

/**
 * The route preamble the FOH tree needs (P7, plan §6). The old single-tree `guards.jsx` also
 * held `BackOfficeLoading` / `PageLoading` and closed over a build-time `LOGIN_PATH`; the
 * back-office half lives in `@verlo/cloud-ui` now, and here `LOGIN_PATH` is simply the PIN
 * kiosk — node-api mounts no `POST /auth/login`, so on the Pi there is nowhere else to send a
 * signed-out user.
 *
 * Tailwind scans source for whole class names, so the tone is written out, not interpolated.
 */

const LOGIN_PATH = '/kiosk';

export const FOHLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-surface-2">
    <div className="animate-pulse text-ink-soft">Loading...</div>
  </div>
);

/**
 * The "still checking / not signed in" preamble. Returns an element to render instead of the
 * page, or `null` to carry on.
 */
export const authGate = ({ user, loading }, Spinner) => {
  if (loading) return <Spinner />;
  if (!user) return <Navigate to={LOGIN_PATH} replace />;
  return null;
};
